var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-carousel',{attrs:{"hide-delimiter-background":"","hide-delimiters":"","cycle":"","height":"600","show-arrows":false,"interval":"4000"}},_vm._l((_vm.banners),function(banner,index){return _c('v-carousel-item',{key:index},[_c('v-img',{staticClass:"banner-image",attrs:{"src":banner.src,"alt":banner.alt}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }